module.exports = __webpack_public_path__ + "img/recycled-material.5c870978.svg";